import React, { ReactNode, useState } from "react"
import clsx from "clsx"
import Container from "@ecom/ui/components/Container"
import pushToDataLayer from "@ecom/ui/utils/pushToDataLayer"
import { TableDescription } from "./TableDescription"
import { ContentProps, generateContent } from "./helpers/helpers"
import * as styles from "./switcherTextBlock.module.scss"
import { QueryTypePsk } from "../../helpers/getVariableFromQuery"

export type Item = {
  title: string
  html: string | JSX.Element
}

export type SwitcherTextBlockProps = {
  title?: ReactNode
  seoBlockText: ContentProps["seoBlockText"]
  mode?: ContentProps["mode"]
  orderNum?: string
  withTableDescription?: boolean
  blockTitle?: boolean
  indent?: boolean
  queryData?: QueryTypePsk | null
  variantStyle?: string
}

export function SwitcherTextBlock({
  title = "Полезная информация",
  seoBlockText,
  mode,
  orderNum,
  withTableDescription = false,
  blockTitle = true,
  indent = false,
  queryData = null,
  variantStyle,
}: SwitcherTextBlockProps) {
  const [activeIndex, setActiveIndex] = useState(0)

  const items = generateContent({ mode, seoBlockText, queryData })

  const onClickHandler = (i: number) => {
    setActiveIndex(i)
    pushToDataLayer({
      event: "buttonClick",
      name: "button_useful_information",
      placement: "useful_information",
    })
  }

  return (
    <section
      data-testid="info"
      data-exclude={orderNum}
      className={clsx(
        styles.section,
        { [styles.indent]: indent },
        variantStyle && styles[variantStyle]
      )}
      id="switcher_content"
    >
      <Container>
        {blockTitle && <h2 className={styles.switcherTitle}>{title}</h2>}
        <div data-testid="container" className={styles.info_title_container}>
          {items.map((item, i) => (
            <React.Fragment key={i}>
              {!seoBlockText && item.title === "Описание" ? null : (
                <button
                  key={i}
                  type="button"
                  onClick={() => onClickHandler(i)}
                  className={clsx(styles.base, activeIndex === i ? styles.active : null)}
                  data-testid={`btn-id-${i}`}
                >
                  <div className={styles.info_title}>{item.title}</div>
                </button>
              )}
            </React.Fragment>
          ))}
        </div>
        {items.map((item, i) =>
          typeof item.html === "string" ? (
            <React.Fragment key={i}>
              <div
                key={i}
                dangerouslySetInnerHTML={{ __html: item.html }}
                className={clsx(styles.htmlBlock, activeIndex === i ? null : styles.displayNone)}
                data-testid={`info-id-${i}`}
              />
              {item.title === "Описание" && withTableDescription && (
                <div
                  className={clsx(styles.htmlBlock, activeIndex === i ? null : styles.displayNone)}
                >
                  <TableDescription />
                </div>
              )}
            </React.Fragment>
          ) : (
            <div
              key={i}
              className={activeIndex === i ? null : styles.displayNone}
              data-testid={`info-id-${i}`}
            >
              {item.html}
            </div>
          )
        )}
      </Container>
    </section>
  )
}
